import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

// 统计卡(迁移自 key-health-check):图例井 + 标签 + 数值 + 附注,
// tone ∈ blue/green/orange/purple。highlight 时红色描边提示异常。
const TONE: Record<string, string> = {
  blue: "bg-[#e9f0ff] text-[#2767e9]",
  green: "bg-[#e7f8ee] text-[#1e9a61]",
  orange: "bg-[#fff2df] text-[#d88325]",
  purple: "bg-[#f0ebff] text-[#7759cf]",
};

export function StatCard({
  label,
  value,
  note,
  icon: Icon,
  tone = "blue",
  highlight = false,
}: {
  label: string;
  value: number | string;
  note?: string;
  icon: LucideIcon;
  tone?: keyof typeof TONE;
  highlight?: boolean;
}) {
  return (
    <div className={cn("flex min-h-[118px] gap-3.5 rounded-lg border bg-card p-5", highlight && "border-destructive")}>
      <div className={cn("grid h-9 w-9 shrink-0 place-items-center rounded-md", TONE[tone])}>
        <Icon size={18} />
      </div>
      <div className="grid content-start gap-1">
        <span className="text-[11px] text-[#78859a]">{label}</span>
        <strong className={cn("text-[27px] leading-[1.1] text-[#152136]", highlight && "text-destructive")}>{value}</strong>
        {note && <small className="text-[10px] text-[#9aa6b7]">{note}</small>}
      </div>
    </div>
  );
}